(function () {
  'use strict';

  if (window.__kkOrbeCountryListLazyInitialized) return;
  window.__kkOrbeCountryListLazyInitialized = true;

  var lazyParkingEnabled = !(window.Shopify && window.Shopify.designMode);
  var list = null;
  var modal = null;
  var parkedNodes = document.createDocumentFragment();
  var readyObserver = null;
  var listObserver = null;
  var modalObserver = null;
  var parkTimer = null;
  var movingNodes = false;

  function orbeIsReady() {
    return document.body && /(^|\s)orbe-country-code--[^\s]+(\s|$)/i.test(document.body.className);
  }

  function modalIsOpen() {
    return modal &&
      modal.isConnected &&
      !modal.classList.contains('orbe--hidden') &&
      modal.getAttribute('aria-hidden') !== 'true';
  }

  function restore() {
    if (parkTimer !== null) {
      window.clearTimeout(parkTimer);
      parkTimer = null;
    }

    if (!list || !list.isConnected || !parkedNodes.childNodes.length) return false;

    movingNodes = true;
    list.appendChild(parkedNodes);
    movingNodes = false;
    list.removeAttribute('data-kk-orbe-country-list-parked');

    return true;
  }

  function park() {
    if (!list || !list.isConnected || modalIsOpen() || !list.childNodes.length) return false;

    movingNodes = true;
    while (list.firstChild) {
      parkedNodes.appendChild(list.firstChild);
    }
    movingNodes = false;
    list.setAttribute('data-kk-orbe-country-list-parked', 'true');

    return true;
  }

  function schedulePark() {
    if (!lazyParkingEnabled) return;

    if (parkTimer !== null) {
      window.clearTimeout(parkTimer);
    }

    parkTimer = window.setTimeout(function () {
      parkTimer = null;
      park();
    }, 0);
  }

  function showOrbeModal() {
    restore();

    try {
      if (window.orbito && typeof window.orbito.openAndRefreshModal === 'function') {
        window.orbito.openAndRefreshModal();
        return true;
      }

      if (window.Orbe && typeof window.Orbe.openAndRefreshModal === 'function') {
        window.Orbe.openAndRefreshModal();
        return true;
      }

      if (window.Orbe && typeof window.Orbe.openModal === 'function') {
        window.Orbe.openModal();
        return true;
      }
    } catch (error) {
      // Fall back to the app embed below if Orbe's public API is not ready yet.
    }

    var embed = document.getElementById('md-app-embed__modal');
    if (!embed) return false;

    modal = embed;
    embed.classList.remove('orbe--hidden');
    embed.removeAttribute('aria-hidden');

    var container = embed.querySelector('.md-modal__container');
    if (container) container.style.display = 'flex';

    var backdrop = embed.querySelector('.md-modal__backdrop');
    if (backdrop) backdrop.style.display = 'block';

    var dialog = embed.querySelector('.md-modal__dialog');
    if (dialog && typeof dialog.focus === 'function') dialog.focus();

    return true;
  }

  function handleOpenIntent(event) {
    if (
      event.type === 'keydown' &&
      event.key !== 'Enter' &&
      event.key !== ' ' &&
      event.key !== 'Spacebar' &&
      event.key !== 'ArrowDown'
    ) {
      return;
    }

    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    var trigger = target.closest(
      '[data-orbe-open-modal], #md-form__select__country, [aria-controls="orbeCountryList"]'
    );
    if (!trigger) return;

    restore();

    if (event.type === 'click' && trigger.matches('[data-orbe-open-modal]')) {
      event.preventDefault();
      showOrbeModal();
    }
  }

  function attach() {
    if (!orbeIsReady()) return false;

    var nextList = document.getElementById('orbeCountryList');
    var nextModal = document.getElementById('md-app-embed__modal');
    if (!nextList || !nextModal) return false;

    list = nextList;
    modal = nextModal;
    parkedNodes = document.createDocumentFragment();

    listObserver = new MutationObserver(function () {
      if (movingNodes) return;

      if (!modalIsOpen()) {
        schedulePark();
      } else if (!list.hasAttribute('hidden')) {
        restore();
      }
    });
    listObserver.observe(list, {
      attributes: true,
      attributeFilter: ['hidden', 'class', 'style'],
      childList: true
    });

    modalObserver = new MutationObserver(function () {
      if (modalIsOpen()) {
        restore();
      } else {
        schedulePark();
      }
    });
    modalObserver.observe(modal, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'style']
    });

    if (readyObserver) readyObserver.disconnect();
    schedulePark();

    return true;
  }

  function initialize() {
    if (attach()) return;

    readyObserver = new MutationObserver(function () {
      attach();
    });
    readyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      if (readyObserver) readyObserver.disconnect();
    }, 15000);
  }

  document.addEventListener('pointerdown', handleOpenIntent, true);
  document.addEventListener('click', handleOpenIntent, true);
  document.addEventListener('keydown', handleOpenIntent, true);

  window.KKOrbeCountryList = {
    restore: restore,
    park: schedulePark,
    open: showOrbeModal,
    isParked: function () {
      return Boolean(list && list.hasAttribute('data-kk-orbe-country-list-parked'));
    }
  };

  if (lazyParkingEnabled) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  }
})();
